import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './assets/main.css'

// Import views
import Home from './views/Home.vue'
import History from './views/History.vue'
import Committee from './views/Committee.vue'
import Performances from './views/Performances.vue'
import News from './views/News.vue'
import Videos from './views/Videos.vue'
import Sponsors from './views/Sponsors.vue'
import Contact from './views/Contact.vue'
import Admin from './views/Admin.vue'
import AdminLogin from './views/AdminLogin.vue'

// Import components
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import Hero from './components/Hero.vue'
import SocialFeed from './components/SocialFeed.vue'
import VideoSection from './components/VideoSection.vue'
import SponsorsSection from './components/SponsorsSection.vue'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/history', name: 'History', component: History },
  { path: '/committee', name: 'Committee', component: Committee },
  { path: '/performances', name: 'Performances', component: Performances },
  { path: '/news', name: 'News', component: News },
  { path: '/videos', name: 'Videos', component: Videos },
  { path: '/sponsors', name: 'Sponsors', component: Sponsors },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/admin/login', name: 'AdminLogin', component: AdminLogin },
  { path: '/admin', name: 'Admin', component: Admin }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const app = createApp(App)

// Register global components
app.component('Navbar', Navbar)
app.component('Footer', Footer)
app.component('Hero', Hero)
app.component('SocialFeed', SocialFeed)
app.component('VideoSection', VideoSection)
app.component('SponsorsSection', SponsorsSection)

app.use(router)
app.mount('#app')
